// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  box-shadow: none;
  background: #222222;
}

.info-bar {
  background: #f8f8f8;
  border-bottom: 1px solid #e0e0e0;
  padding: 12px 16px;
}
.info-bar .info-bar-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}
.info-bar .info-bar-content .info-text {
  font-family: AppFont;
  font-size: 12px;
  line-height: 1.4;
  color: #333;
}
@media (min-width: 991px) {
  .info-bar .info-bar-content .info-text {
    font-size: 14px;
  }
}
.info-bar .info-bar-content .info-text .info-link {
  color: var(--ion-color-primary);
  text-decoration: underline;
  font-weight: 500;
}
.info-bar .info-bar-content .info-text .info-link:hover {
  color: var(--ion-color-primary-tint);
}

.venue_info_block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 50px 14px 15px;
}

.lang-icon {
  height: 18px;
  width: 18px;
  border: 1.5px solid white;
  border-radius: 50%;
}

.logo-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  position: absolute;
  left: 0;
  right: 0;
}

.logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 36px;
  width: 86px;
}

.right-slot {
  display: flex;
  align-items: center;
}
.right-slot .table-chip {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background: #fff;
  height: 26px;
  padding-inline: 9px;
  margin-right: 14px;
}
.right-slot .table-chip-text {
  font-family: AppFontBold;
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 0.02em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #000;
  margin-right: 6px;
}
.right-slot .table-chip-number {
  font-family: Title;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #222222;
}

.main_row {
  height: 100%;
}
.main_row .category_col {
  background: #f3f3f3;
}
.main_row .category_col .category_item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 5px 10px 10px;
  margin-top: 1.5px;
  background: #f3f3f3;
  border-radius: 0px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1.5px solid rgba(79, 97, 79, 0.1019607843);
}
.main_row .category_col .category_item ion-img {
  width: 60px;
  margin-right: 10px;
}
.main_row .category_col .category_item h3 {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  color: var(--ion-color-secondary);
}
.main_row .category_col .category_item:first-of-type {
  margin-top: 0px;
}
.main_row .category_col .category_item.selected {
  background: var(--ion-color-primary);
  color: #fff;
}
.main_row .category_col .category_item.selected h3 {
  color: white;
}
.main_row .border_top_line {
  width: 100%;
  height: 3px;
  background: #d9d9d9;
}
.main_row .category_name {
  font-family: AppFontMedium;
  font-size: 17px;
  letter-spacing: 0em;
  text-align: left;
  padding: 30px 0px 20px 7px;
}
.main_row .item_row {
  margin: 0 10px;
}
@media (min-width: 991px) {
  .main_row .item_row {
    margin: 0 0px 0 10px;
  }
}
.main_row .catalog_col {
  position: relative;
  overflow: hidden;
  padding: 0;
}
.main_row .order-col {
  padding-top: 23px;
}

.item-col {
  margin-bottom: 12px;
}
@media (min-width: 991px) {
  .item-col {
    margin-bottom: 0px;
    padding: 0px 7px 13px;
  }
}

.category-row {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-block: 23px;
}
@media (min-width: 991px) {
  .category-row {
    justify-content: flex-start;
    padding-left: 13px;
  }
}
.category-row h2 {
  font-family: Title;
  font-size: 40px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
  color: #222222;
}

.search_col {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search_col ion-searchbar {
  --box-shadow: 0px 0px 42px 0px #00000012;
  --border-radius: 10px;
}
.search_col .open_filters {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  box-shadow: 0px 0px 42px 0px rgba(0, 0, 0, 0.0705882353);
}
.search_col .open_filters ion-icon {
  zoom: 1.3;
}

.footer-btn-desktop {
  position: absolute;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  width: 40%;
  text-align: center;
  display: flex;
  justify-content: center;
}
.footer-btn-desktop ion-button {
  width: 100%;
}

.order_list_row {
  height: 100%;
  display: flex;
}
.order_list_row app-order-content {
  width: 100%;
}

.filers_section {
  background: var(--color-background-alt);
}
@media (max-width: 992px) {
  .filers_section {
    border-bottom: 1px solid #222222;
  }
}

.main-content {
  --padding-start: 0%;
  --padding-end: 0%;
}

.main-content::part(scroll)::-webkit-scrollbar {
  display: none;
}

.main-content::part(scroll) {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.display-flex {
  display: flex;
}

.category-list {
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
  padding-bottom: 18px;
  height: 53px;
}
@media (min-width: 991px) {
  .category-list {
    justify-content: center;
    flex-grow: 1;
  }
  .category-list > ion-chip {
    overflow: unset;
    display: flex;
    flex-grow: 1 !important;
  }
}
.category-list::-webkit-scrollbar {
  display: none;
}
.category-list ion-chip {
  flex: 0 0 auto;
  height: 30px;
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin: 0px 3px;
  --background: transparent;
  border-radius: 50px;
  border: 1px solid var(--ion-color-primary);
  transition: 200ms linear;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
@media (min-width: 991px) {
  .category-list ion-chip {
    height: 35px;
  }
  .category-list ion-chip:hover {
    --background: var(--ion-color-primary-tint);
  }
  .category-list ion-chip:hover p {
    color: white;
  }
}
.category-list ion-chip:first-child {
  margin-left: 15px;
}
.category-list ion-chip:last-child {
  margin-right: 15px;
}
.category-list ion-chip p {
  font-family: AppFontBold;
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 0.08em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--ion-color-primary);
  margin: 0;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
@media (min-width: 991px) {
  .category-list ion-chip p {
    font-size: 14px;
  }
}
.category-list ion-chip ion-icon,
.category-list ion-chip ion-img {
  height: 31px;
  width: 31px;
  margin-right: 5px;
}
.category-list ion-chip.selected {
  transition: 200ms linear;
  background: var(--ion-color-primary);
}
.category-list ion-chip.selected p {
  color: white;
}
.category-list ion-chip.selected ion-icon {
  fill: var(--ion-color-primary);
}

.filters-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  border-top: 1px solid rgba(232, 232, 224, 0.1019607843);
}
.filters-block .common-filter,
.filters-block .vegan-filter {
  height: 100%;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.filters-block .common-filter {
  border-right: 1px solid rgba(232, 232, 224, 0.1019607843);
}
.filters-block .common-filter .filter-icon {
  height: 100%;
  width: 35px;
  margin-right: 7px;
}
.filters-block .switcher {
  position: relative;
  background: var(--ion-color-primary);
  border-radius: 50px;
  height: 23px;
  width: 63px;
  border: 1px solid #000000;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 6px;
}
.filters-block .switcher .switch-toggler {
  position: absolute;
  left: 0%;
  top: 0%;
  height: 100%;
  width: 42px;
  background-color: #e8e8df;
  border: 1px solid #000000;
  border-radius: 50px;
  transition: left 0.3s ease-in-out, background 0.3s ease-in-out;
}
.filters-block .switcher .switch-toggler.selected {
  left: 32%;
  background: var(--ion-color-primary);
}
.filters-block .filters-text {
  font-family: AppFont;
  font-size: 12px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
  color: #fbfbfb;
}

.drink-filters-row {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-block: 23px;
}
@media (min-width: 991px) {
  .drink-filters-row {
    justify-content: flex-start;
  }
}

.drink-subcategory-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 14px 12px 14px;
}
.drink-subcategory-filters .subcategory-chip {
  background: transparent;
  border: 1px solid var(--ion-color-primary);
  border-radius: 16px;
  padding: 4px 10px;
  margin: 0;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 28px;
}
.drink-subcategory-filters .subcategory-chip p {
  font-family: AppFont;
  font-size: 10px;
  font-weight: 500;
  color: var(--ion-color-primary);
  margin: 0;
  line-height: 1.2;
}
.drink-subcategory-filters .subcategory-chip.selected {
  background: var(--ion-color-primary);
  border-color: var(--ion-color-primary);
}
.drink-subcategory-filters .subcategory-chip.selected p {
  color: white;
  font-weight: 600;
}
.drink-subcategory-filters .subcategory-chip:hover:not(.selected) {
  background: rgba(255, 255, 255, 0.08);
  border-color: #666;
}

.more {
  min-height: 400px !important;
  width: 100%;
}
@media (max-width: 992px) {
  .more {
    min-height: 250px !important;
    width: 100%;
  }
}

.filter-toggle {
  display: flex;
  justify-content: center;
  padding: 10px 0px;
}

.no_items {
  width: 100%;
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.max-height-100 {
  max-height: 100%;
}

.order_basket_block {
  position: absolute;
  z-index: 20;
  height: 99%;
  width: 400px;
  background: #fbfbfb;
  right: -400px;
  top: -1px;
  transition: right 0.3s;
}
.order_basket_block.open {
  right: 0;
  box-shadow: -26px 11px 79px -10px rgb(149, 149, 149);
}
.order_basket_block .order_basket_header .close_basket_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding-left: 20px;
  font-family: AppFont;
  font-size: 14px;
  letter-spacing: 0em;
  color: var(--ion-color-black);
  background: #f9f9f9;
}
.order_basket_block .order_basket_header .close_basket_img_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d9d9d9;
  padding: 0 16.5px;
  height: 55px;
  width: 55px !important;
}
.order_basket_block .order_basket_header .close_basket_img_col .close_basket_img {
  height: 14px;
  width: 14px;
}

.fixed-notification {
  pointer-events: none;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: #f2dbd9;
  color: var(--color-black);
  font-family: AppFontMedium;
  text-transform: uppercase;
  text-align: center;
  padding: 20px;
  min-height: 0px;
  height: 0px;
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
}
.fixed-notification.show-item {
  opacity: 1;
  height: -moz-fit-content;
  height: fit-content;
  min-height: -moz-fit-content;
  min-height: fit-content;
}
@media (max-width: 992px) {
  .fixed-notification {
    bottom: 70px;
    font-size: 14px;
  }
}

.show-basket {
  min-width: 200px;
  position: relative;
  min-height: 35px;
}
.show-basket ion-icon {
  margin-right: 10px;
  color: white;
}
@media (max-width: 992px) {
  .show-basket {
    display: none;
  }
}
.show-basket:hover {
  --background: var(--ion-color-primary) !important;
}
.show-basket h4 {
  color: white;
  font-size: 14px;
  font-family: AppFontBold;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/menu/menu.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAKA;EACC,gBAAA;EACA,mBAAA;AAJD;;AAOA;EACC,mBAAA;EACA,gCAAA;EACA,kBAAA;AAJD;AAMC;EACC,iBAAA;EACA,cAAA;EACA,kBAAA;AAJF;AAME;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAJH;ACnBE;EDmBA;IAOE,eAAA;EAHF;AACF;AAKG;EACC,+BAAA;EACA,0BAAA;EACA,gBAAA;AAHJ;AAKI;EACC,oCAAA;AAHL;;AAUA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;AAPD;;AAUA;EACC,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAPD;;AAUA;EACC,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AARD;;AAUA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EAEA,YAAA;EACA,WAAA;AARD;;AAWA;EACC,aAAA;EACA,mBAAA;AARD;AASC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,YAAA;EACA,mBAAA;EACA,kBAAA;AATF;AAWE;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;EAEA,iBAAA;AAVH;AAaE;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,cAAA;AAZH;;AAiBA;EACC,YAAA;AAdD;AAgBC;EACC,mBAAA;AAdF;AAeE;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EAEA,mBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,yDAAA;AAfH;AAgBG;EACC,WAAA;EACA,kBAAA;AAdJ;AAgBG;EACC,oCAAA;EACA,eAAA;EACA,iCAAA;AAdJ;AAiBG;EACC,eAAA;AAfJ;AAkBG;EACC,oCAAA;EACA,WAAA;AAhBJ;AAiBI;EACC,YAAA;AAfL;AAoBC;EACC,WAAA;EACA,WAAA;EACA,mBAAA;AAlBF;AAoBC;EACC,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EAEA,0BAAA;AAnBF;AAsBC;EACC,cAAA;AApBF;AC7JE;EDgLD;IAIE,oBAAA;EAnBD;AACF;AAsBC;EACC,kBAAA;EACA,gBAAA;EACA,UAAA;AApBF;AAuBC;EACC,iBAAA;AArBF;;AAyBA;EACC,mBAAA;AAtBD;AC9KE;EDmMF;IAGE,kBAAA;IAEA,qBAAA;EArBA;AACF;;AAwBA;EACC,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AArBD;AC5LE;ED4MF;IAQE,2BAAA;IACA,kBAAA;EApBA;AACF;AAqBC;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AAnBF;;AAuBA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AApBD;AAqBC;EACC,wCAAA;EACA,qBAAA;AAnBF;AAqBC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wDAAA;AAnBF;AAoBE;EACC,SAAA;AAlBH;;AAuBA;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AApBD;AAqBC;EACC,WAAA;AAnBF;;AAuBA;EACC,YAAA;EACA,aAAA;AApBD;AAqBC;EACC,WAAA;AAnBF;;AAuBA;EACC,uCAAA;AApBD;ACtPE;EDyQF;IAGE,gCAAA;EAlBA;AACF;;AAqBA;EACC,mBAAA;EACA,iBAAA;AAlBD;;AAqBA;EACC,aAAA;AAlBD;;AAoBA;EACC,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AAjBD;;AAoBA;EACC,aAAA;AAjBD;;AAoBA;EACC,aAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA,EAAA,YAAA;EACA,oBAAA;EACA,YAAA;AAjBD;AC7RE;EDuSF;IAUE,uBAAA;IACA,YAAA;EAhBA;EAiBA;IACC,eAAA;IACA,aAAA;IACA,uBAAA;EAfD;AACF;AAkBC;EACC,aAAA;AAhBF;AAmBC;EACC,cAAA;EACA,YAAA;EAEA,2BAAA;EAAA,sBAAA;EACA,eAAA;EAEA,yBAAA;EACA,mBAAA;EACA,0CAAA;EAEA,wBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,gBAAA;AAtBF;ACzTE;ED8TD;IAoBE,YAAA;EArBD;EAsBC;IACC,2CAAA;EApBF;EAqBE;IACC,YAAA;EAnBH;AACF;AAuBE;EACC,iBAAA;AArBH;AAwBE;EACC,kBAAA;AAtBH;AAyBE;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;EAEA,SAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AAxBH;AC5VE;EDmWA;IAoBE,eAAA;EAvBF;AACF;AAyBE;;EAEC,YAAA;EACA,WAAA;EACA,iBAAA;AAvBH;AA0BE;EACC,wBAAA;EACA,oCAAA;AAxBH;AAyBG;EACC,YAAA;AAvBJ;AA0BG;EACC,8BAAA;AAxBJ;;AA8BA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,uDAAA;AA3BD;AA6BC;;EAEC,YAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA3BF;AA8BC;EACC,yDAAA;AA5BF;AA8BE;EACC,YAAA;EACA,WAAA;EACA,iBAAA;AA5BH;AAgCC;EACC,kBAAA;EACA,oCAAA;EACA,mBAAA;EAEA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EAEA,iBAAA;AAhCF;AAkCE;EACC,kBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EAEA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8DAAA;AAjCH;AAmCG;EACC,SAAA;EACA,oCAAA;AAjCJ;AAsCC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,cAAA;AApCF;;AAwCA;EACC,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AArCD;ACtbE;EDsdF;IAQE,2BAAA;EApCA;AACF;;AAuCA;EACC,aAAA;EACA,eAAA;EACA,QAAA;EACA,yBAAA;AApCD;AAsCC;EACC,uBAAA;EACA,0CAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AApCF;AAsCE;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;EACA,gBAAA;AApCH;AAuCE;EACC,oCAAA;EACA,sCAAA;AArCH;AAuCG;EACC,YAAA;EACA,gBAAA;AArCJ;AAyCE;EACC,qCAAA;EACA,kBAAA;AAvCH;;AA4CA;EACC,4BAAA;EACA,WAAA;AAzCD;AC/dE;EDsgBF;IAIE,4BAAA;IACA,WAAA;EAvCA;AACF;;AA0CA;EACC,aAAA;EACA,uBAAA;EACA,iBAAA;AAvCD;;AAyCA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAtCD;;AAyCA;EACC,gBAAA;AAtCD;;AAyCA;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EAEA,YAziB0B;EA0iB1B,mBAAA;EAGA,aAAA;EACA,SAAA;EAEA,sBAAA;AA1CD;AA4CC;EACC,QAAA;EAGA,oDAAA;AA1CF;AA8CE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;AA7CH;AAgDE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AA9CH;AA+CG;EACC,YAAA;EACA,WAAA;AA7CJ;;AAkDA;EACC,oBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,oCAAA;EACA,UAAA;AA/CD;AAiDC;EACC,UAAA;EACA,wBAAA;EAAA,mBAAA;EACA,4BAAA;EAAA,uBAAA;AA/CF;ACxjBE;EDmlBF;IAuBE,YAAA;IACA,eAAA;EA9CA;AACF;;AAiDA;EACC,gBAAA;EACA,kBAAA;EACA,gBAAA;AA9CD;AA+CC;EACC,kBAAA;EACA,YAAA;AA7CF;ACxkBE;ED+mBF;IASE,aAAA;EA5CA;AACF;AA6CC;EACC,iDAAA;AA3CF;AA6CC;EACC,YAAA;EACA,eAAA;EACA,wBAAA;AA3CF","sourcesContent":["@import '../../../theme/mixins';\n\n$container_padding_top: 30px;\n$order_basket_block_width: 400px;\n\nion-header {\n\tbox-shadow: none;\n\tbackground: #222222;\n}\n\n.info-bar {\n\tbackground: #f8f8f8;\n\tborder-bottom: 1px solid #e0e0e0;\n\tpadding: 12px 16px;\n\n\t.info-bar-content {\n\t\tmax-width: 1200px;\n\t\tmargin: 0 auto;\n\t\ttext-align: center;\n\n\t\t.info-text {\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 1.4;\n\t\t\tcolor: #333;\n\n\t\t\t@include desktop {\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\n\t\t\t.info-link {\n\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\ttext-decoration: underline;\n\t\t\t\tfont-weight: 500;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: var(--ion-color-primary-tint);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.venue_info_block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 50px 14px 15px;\n}\n\n.lang-icon {\n\theight: 18px;\n\twidth: 18px;\n\tborder: 1.5px solid white;\n\tborder-radius: 50%;\n}\n\n.logo-wrapper {\n\tposition: relative;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\twidth: 100vw;\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n}\n.logo {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\n\theight: 36px;\n\twidth: 86px;\n}\n\n.right-slot {\n\tdisplay: flex;\n\talign-items: center;\n\t.table-chip {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tborder-radius: 6px;\n\t\tbackground: #fff;\n\n\t\theight: 26px;\n\t\tpadding-inline: 9px;\n\t\tmargin-right: 14px;\n\n\t\t&-text {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 10px;\n\t\t\tline-height: 120%;\n\t\t\tletter-spacing: 0.02em;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: #000;\n\n\t\t\tmargin-right: 6px;\n\t\t}\n\n\t\t&-number {\n\t\t\tfont-family: Title;\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 25px;\n\t\t\tletter-spacing: 0%;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\n\t\t\tcolor: #222222;\n\t\t}\n\t}\n}\n\n.main_row {\n\theight: 100%;\n\n\t.category_col {\n\t\tbackground: #f3f3f3;\n\t\t.category_item {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-start;\n\t\t\talign-items: center;\n\t\t\tpadding: 10px 5px 10px 10px;\n\t\t\tmargin-top: 1.5px;\n\n\t\t\tbackground: #f3f3f3;\n\t\t\tborder-radius: 0px;\n\n\t\t\ttransition: all 0.3s;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: flex-start;\n\t\t\tborder-bottom: 1.5px solid #4f614f1a;\n\t\t\tion-img {\n\t\t\t\twidth: 60px;\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\t\t\th3 {\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t}\n\n\t\t\t&:first-of-type {\n\t\t\t\tmargin-top: 0px;\n\t\t\t}\n\n\t\t\t&.selected {\n\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\tcolor: #fff;\n\t\t\t\th3 {\n\t\t\t\t\tcolor: white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.border_top_line {\n\t\twidth: 100%;\n\t\theight: 3px;\n\t\tbackground: #d9d9d9;\n\t}\n\t.category_name {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 17px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\n\t\tpadding: 30px 0px 20px 7px;\n\t}\n\n\t.item_row {\n\t\tmargin: 0 10px;\n\n\t\t@include desktop {\n\t\t\tmargin: 0 0px 0 10px;\n\t\t}\n\t}\n\n\t.catalog_col {\n\t\tposition: relative;\n\t\toverflow: hidden;\n\t\tpadding: 0;\n\t}\n\n\t.order-col {\n\t\tpadding-top: 23px;\n\t}\n}\n\n.item-col {\n\tmargin-bottom: 12px;\n\t@include desktop {\n\t\tmargin-bottom: 0px;\n\t\t// padding-inline: 13px;\n\t\tpadding: 0px 7px 13px;\n\t}\n}\n\n.category-row {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding-block: 23px;\n\n\t@include desktop {\n\t\tjustify-content: flex-start;\n\t\tpadding-left: 13px;\n\t}\n\th2 {\n\t\tfont-family: Title;\n\t\tfont-size: 40px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tcolor: #222222;\n\t}\n}\n\n.search_col {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tion-searchbar {\n\t\t--box-shadow: 0px 0px 42px 0px #00000012;\n\t\t--border-radius: 10px;\n\t}\n\t.open_filters {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 42px;\n\t\theight: 42px;\n\t\tborder-radius: 10px;\n\t\tbox-shadow: 0px 0px 42px 0px #00000012;\n\t\tion-icon {\n\t\t\tzoom: 1.3;\n\t\t}\n\t}\n}\n\n.footer-btn-desktop {\n\tposition: absolute;\n\tbottom: 35px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\twidth: 40%;\n\ttext-align: center;\n\tdisplay: flex;\n\tjustify-content: center;\n\tion-button {\n\t\twidth: 100%;\n\t}\n}\n\n.order_list_row {\n\theight: 100%;\n\tdisplay: flex;\n\tapp-order-content {\n\t\twidth: 100%;\n\t}\n}\n\n.filers_section {\n\tbackground: var(--color-background-alt);\n\t@include mobile {\n\t\tborder-bottom: 1px solid #222222;\n\t}\n}\n\n.main-content {\n\t--padding-start: 0%;\n\t--padding-end: 0%;\n}\n\n.main-content::part(scroll)::-webkit-scrollbar {\n\tdisplay: none;\n}\n.main-content::part(scroll) {\n\t-ms-overflow-style: none; /* IE and Edge */\n\tscrollbar-width: none; /* Firefox */\n}\n\n.display-flex {\n\tdisplay: flex;\n}\n\n.category-list {\n\tdisplay: flex;\n\toverflow: auto;\n\tscroll-behavior: smooth;\n\t-ms-overflow-style: none;\n\tscrollbar-width: none; /* Firefox */\n\tpadding-bottom: 18px;\n\theight: 53px;\n\n\t@include desktop {\n\t\tjustify-content: center;\n\t\tflex-grow: 1;\n\t\t> ion-chip {\n\t\t\toverflow: unset;\n\t\t\tdisplay: flex;\n\t\t\tflex-grow: 1 !important;\n\t\t}\n\t}\n\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\tion-chip {\n\t\tflex: 0 0 auto;\n\t\theight: 30px;\n\n\t\tmax-width: fit-content;\n\t\tmargin: 0px 3px;\n\n\t\t--background: transparent;\n\t\tborder-radius: 50px;\n\t\tborder: 1px solid var(--ion-color-primary);\n\n\t\ttransition: 200ms linear;\n\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\toverflow: hidden;\n\n\t\t@include desktop {\n\t\t\theight: 35px;\n\t\t\t&:hover {\n\t\t\t\t--background: var(--ion-color-primary-tint);\n\t\t\t\tp {\n\t\t\t\t\tcolor: white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&:first-child {\n\t\t\tmargin-left: 15px;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tmargin-right: 15px;\n\t\t}\n\n\t\tp {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 10px;\n\t\t\tline-height: 120%;\n\t\t\tletter-spacing: 0.08em;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--ion-color-primary);\n\n\t\t\tmargin: 0;\n\t\t\tword-break: break-word;\n\t\t\tdisplay: -webkit-box;\n\t\t\t-webkit-line-clamp: 1;\n\t\t\t-webkit-box-orient: vertical;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\ttext-align: center;\n\n\t\t\t@include desktop {\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\t\t}\n\t\tion-icon,\n\t\tion-img {\n\t\t\theight: 31px;\n\t\t\twidth: 31px;\n\t\t\tmargin-right: 5px;\n\t\t}\n\n\t\t&.selected {\n\t\t\ttransition: 200ms linear;\n\t\t\tbackground: var(--ion-color-primary);\n\t\t\tp {\n\t\t\t\tcolor: white;\n\t\t\t}\n\n\t\t\tion-icon {\n\t\t\t\tfill: var(--ion-color-primary);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.filters-block {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\theight: 50px;\n\tborder-top: 1px solid #e8e8e01a;\n\n\t.common-filter,\n\t.vegan-filter {\n\t\theight: 100%;\n\t\twidth: 50%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\t}\n\n\t.common-filter {\n\t\tborder-right: 1px solid #e8e8e01a;\n\n\t\t.filter-icon {\n\t\t\theight: 100%;\n\t\t\twidth: 35px;\n\t\t\tmargin-right: 7px;\n\t\t}\n\t}\n\n\t.switcher {\n\t\tposition: relative;\n\t\tbackground: var(--ion-color-primary);\n\t\tborder-radius: 50px;\n\n\t\theight: 23px;\n\t\twidth: 63px;\n\t\tborder: 1px solid #000000;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\n\t\tmargin-right: 6px;\n\n\t\t.switch-toggler {\n\t\t\tposition: absolute;\n\t\t\tleft: 0%;\n\t\t\ttop: 0%;\n\t\t\theight: 100%;\n\t\t\twidth: 42px;\n\n\t\t\tbackground-color: #e8e8df;\n\t\t\tborder: 1px solid #000000;\n\t\t\tborder-radius: 50px;\n\t\t\ttransition: left 0.3s ease-in-out, background 0.3s ease-in-out;\n\n\t\t\t&.selected {\n\t\t\t\tleft: 32%;\n\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t}\n\t\t}\n\t}\n\n\t.filters-text {\n\t\tfont-family: AppFont;\n\t\tfont-size: 12px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\tvertical-align: middle;\n\t\ttext-transform: capitalize;\n\t\tcolor: #fbfbfb;\n\t}\n}\n\n.drink-filters-row {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding-block: 23px;\n\n\t@include desktop {\n\t\tjustify-content: flex-start;\n\t}\n}\n\n.drink-subcategory-filters {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tgap: 8px;\n\tpadding: 0 14px 12px 14px;\n\t\n\t.subcategory-chip {\n\t\tbackground: transparent;\n\t\tborder: 1px solid var(--ion-color-primary);\n\t\tborder-radius: 16px;\n\t\tpadding: 4px 10px;\n\t\tmargin: 0;\n\t\tcursor: pointer;\n\t\ttransition: all 0.3s ease;\n\t\tmin-height: 28px;\n\t\t\n\t\tp {\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 10px;\n\t\t\tfont-weight: 500;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t\tmargin: 0;\n\t\t\tline-height: 1.2;\n\t\t}\n\t\t\n\t\t&.selected {\n\t\t\tbackground: var(--ion-color-primary);\n\t\t\tborder-color: var(--ion-color-primary);\n\t\t\t\n\t\t\tp {\n\t\t\t\tcolor: white;\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\t\t}\n\t\t\n\t\t&:hover:not(.selected) {\n\t\t\tbackground: rgba(255, 255, 255, 0.08);\n\t\t\tborder-color: #666;\n\t\t}\n\t}\n}\n\n.more {\n\tmin-height: 400px !important;\n\twidth: 100%;\n\t@include mobile {\n\t\tmin-height: 250px !important;\n\t\twidth: 100%;\n\t}\n}\n\n.filter-toggle {\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding: 10px 0px;\n}\n.no_items {\n\twidth: 100%;\n\theight: 70vh;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.max-height-100 {\n\tmax-height: 100%;\n}\n\n.order_basket_block {\n\tposition: absolute;\n\tz-index: 20;\n\theight: 99%;\n\n\twidth: $order_basket_block_width;\n\tbackground: #fbfbfb;\n\t// box-shadow: 0px 4px 4px 0px #00000040;\n\n\tright: calc($order_basket_block_width * (-1));\n\ttop: -1px;\n\n\ttransition: right 0.3s;\n\n\t&.open {\n\t\tright: 0;\n\t\t-webkit-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t\t-moz-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t\tbox-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t}\n\n\t.order_basket_header {\n\t\t.close_basket_col {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tbackground: transparent;\n\t\t\tpadding-left: 20px;\n\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 14px;\n\t\t\tletter-spacing: 0em;\n\t\t\tcolor: var(--ion-color-black);\n\t\t\tbackground: #f9f9f9;\n\t\t}\n\n\t\t.close_basket_img_col {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tbackground: #d9d9d9;\n\t\t\tpadding: 0 16.5px;\n\t\t\theight: 55px;\n\t\t\twidth: 55px !important;\n\t\t\t.close_basket_img {\n\t\t\t\theight: 14px;\n\t\t\t\twidth: 14px;\n\t\t\t}\n\t\t}\n\t}\n}\n.fixed-notification {\n\tpointer-events: none;\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\tright: 0px;\n\tbackground: #f2dbd9;\n\tcolor: var(--color-black);\n\tfont-family: AppFontMedium;\n\ttext-transform: uppercase;\n\ttext-align: center;\n\tpadding: 20px;\n\tmin-height: 0px;\n\theight: 0px;\n\ttransition: opacity 0.3s ease-in-out;\n\topacity: 0;\n\n\t&.show-item {\n\t\topacity: 1;\n\t\theight: fit-content;\n\t\tmin-height: fit-content;\n\t}\n\t@include mobile {\n\t\tbottom: 70px;\n\t\tfont-size: 14px;\n\t}\n}\n\n.show-basket {\n\tmin-width: 200px;\n\tposition: relative;\n\tmin-height: 35px;\n\tion-icon {\n\t\tmargin-right: 10px;\n\t\tcolor: white;\n\t}\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\t&:hover {\n\t\t--background: var(--ion-color-primary) !important;\n\t}\n\th4 {\n\t\tcolor: white;\n\t\tfont-size: 14px;\n\t\tfont-family: AppFontBold;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
